import { useMediaQuery } from '@mui/material';
import { Box, useTheme } from '@mui/system';
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { imageBase } from '../../api/client';
import LinearProgress from '../../component/linearProgress/LinearProgress';
import { tagsDate } from '../../helpers/dataHelper';
import useSearchParams from '../../hooks/useSearchParams';
import { QueryToolDetailsMapped } from '../../redux/slices/tools/toolsInterface';
import { getProductToolsById, listProductTools, productToolsFetching } from '../../redux/slices/tools/toolsSlice';
import { useDispatch } from '../../redux/store';
import { Card } from '../../styled/components';
import Table from '../table/Table';
import { LocationVisitsProps } from './interface';

export const StockInstalled: React.FC<LocationVisitsProps> = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [params] = useSearchParams();
  const siteDetails = useSelector(getProductToolsById({ productTypeId: '2', trackingSiteId: id }));
  const fetching = useSelector(productToolsFetching);
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'), { noSsr: true });

  useEffect(() => {
    if (id) {
      dispatch(listProductTools({ productTypeId: '2', trackingSiteId: id }));
    }
  }, [dispatch, id, params]);

  const columns = useMemo(
    () => [
      ...(isSmUp
        ? [
            {
              accessor: 'image_key',
              Header: 'Image',
              Cell: ({ row }: { row: { original: QueryToolDetailsMapped } }) => (
                <Link to={`/stock/items/${row.original.item_id}/details`}>
                  {row.original.image_key && (
                    <img src={`${imageBase(row.original.image_key)}?height=36`} key={row.original.item_id} alt={row.original.product_name} />
                  )}
                </Link>
              ),
              disableSortBy: true,
              width: 50,
              style: { paddingTop: 2, paddingBottom: 2, textAlign: 'center' },
            },
          ]
        : []),
      {
        Header: 'Item - Product',
        accessor: 'identifier',
        ellipsis: true,
        Cell: ({ row }: { row: { original: QueryToolDetailsMapped } }) => (
          <Box
            sx={{
              borderRadius: 1,
              borderWidth: 1,
              borderStyle: 'solid',
              borderColor: 'transparent',
            }}
          >
            <Link to={`/stock/items/${row.original.item_id}/details`}>
              {row.original.identifier} - {row.original.product_name}
            </Link>
          </Box>
        ),
      },
      {
        Header: 'Manufacturer',
        accessor: 'manufacturer_name',
        ellipsis: true,
        Cell: ({ row }: { row: { original: QueryToolDetailsMapped } }) => (
          <Link to={`/tools/manufacturers/${row.original.manufacturer_id}/details`}>{row.original.manufacturer_name}</Link>
        ),
      },
      {
        Header: 'Last Seen',
        accessor: 'processed_at',
        Cell: ({ row }: { row: { original: QueryToolDetailsMapped } }) => (row.original.processed_at ? tagsDate(row.original.processed_at) : ''),
      },
      {
        Header: 'Delivered By',
        accessor: 'payload_warehouse_name',
      },
    ],
    [isSmUp],
  );

  return (
    <>
      {fetching && <LinearProgress />}
      <Card>
        <Table columns={columns} data={siteDetails?.result || []} loading={fetching} withPagination={false} />
      </Card>
    </>
  );
};
